module.exports = __webpack_public_path__ + "img/ScreenshotSpfxSettings.ca2bb604.png";